<div class="notifications">
  <div *ngIf="!loading">
    <div class="display-mobile notifications__mobile notifications__mobile-header">
      <div class="notifications__mobile-title">{{ 'NOTIFICATIONS.notifications' | translate }}</div>
      <button class="btn btn--link notifications__mobile-close" (click)="closeNotificationAside()">
        <img src="assets/img/icons/filters-close-gray.svg" />
      </button>
    </div>
    <div class="notifications__wrapper">
      <div class="notifications__header">
        <div class="notifications__section" *ngIf="notificationsUnseen.length > 0">
          {{ 'NOTIFICATIONS.new' | translate }}
        </div>
        <div class="notifications__clear" *ngIf="notificationLength">
          <button class="btn btn--link" (click)="clearAllNotifications()">
            {{ 'NOTIFICATIONS.clear_all' | translate }}
          </button>
        </div>
      </div>
      <div
        class="notifications__single"
        [ngClass]="{ is__reading: item.is_reading }"
        *ngFor="let item of notificationsUnseen"
      >
        <app-notification-content
          [item]="item"
          (click)="markAsReadAndRedirect(item)"
        ></app-notification-content>
      </div>
    </div>
    <div
      class="notifications__separator"
      *ngIf="notificationsUnseen.length > 0 && notificationsSeen.length > 0"
    ></div>
    <div class="notifications__wrapper">
      <div class="notifications__header" *ngIf="notificationsSeen.length > 0">
        <div class="notifications__section">{{ 'NOTIFICATIONS.earlier' | translate }}</div>
      </div>
      <div
        class="notifications__single"
        [ngClass]="{ is__reading: item.is_reading }"
        *ngFor="let item of notificationsSeen"
      >
        <app-notification-content
          [item]="item"
          (click)="markAsReadAndRedirect(item)"
        ></app-notification-content>
      </div>
    </div>
  </div>
  <app-ph-loader [show]="loading" [fullscreen]="false" [static]="true"></app-ph-loader>
  <div class="notifications__empty" *ngIf="!notificationLength && !loading">
    {{ 'NOTIFICATIONS.no_data' | translate }}
  </div>
</div>
